import { VStack } from '@revolut-internal/ui-kit'
import { FC, PropsWithChildren } from 'react'

import { ChatMessageWrapper, MessageColorSchema } from 'components'
import { AuthorRole, Message } from 'lib/apiClient'
import { MessageBubble } from 'components/ChatMessage/components'

interface DebugChatMessageLayoutProps extends PropsWithChildren {
  message: Message
  colorSchema: MessageColorSchema
  isSelected?: boolean
  onClick?: () => void
}

export const DebugChatMessageLayout: FC<DebugChatMessageLayoutProps> = ({
  message,
  colorSchema,
  onClick,
  isSelected,
  children,
}) => {
  const isUserMessage = message.authorRole === AuthorRole.Customer

  return (
    <ChatMessageWrapper
      isUserMessage={isUserMessage}
      data-testid={`message-bubble-${message.messageId}`}
    >
      <VStack maxWidth="80%" onClick={onClick}>
        <MessageBubble
          colorSchema={colorSchema}
          position={isUserMessage ? 'right' : 'left'}
          isInteractable={Boolean(onClick)}
          isSelected={isSelected}
        >
          {children}
        </MessageBubble>
      </VStack>
    </ChatMessageWrapper>
  )
}
